import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators'
import userService from '@/services/user.service';
import IComptage from "@/types/comptage.interface";

@Module({namespaced: true})
export default class UserModule extends VuexModule {
    public user = {name: "", notifications: [], credits: 0};
    public role = {
        "app_dig": false,
        "app_dig_comptage": false,
        "app_dig_enrichissement": false,
        "app_dig_sirenisation": false,
    };

    public path = '';
    public itemName = '';
    public editFromBasket = false;

    @Mutation
    public setItemName(actualName: string) {
        this.itemName = actualName;
        return true;
    }

    @Mutation
    public setPath(actualPath: string) {
        this.path = actualPath;
        return true;
    }

    @Mutation
    public setEditFromBasket(edit: boolean) {
        this.editFromBasket = edit;
    }

    @Mutation
    public getRole() {
        return this.role;
    }

    @Mutation
    public setUser(newUser: any) {
        this.user = newUser;
        return true;
    }

    @Mutation
    public setCredits(credits: number) {
        this.user.credits = credits;
        return true;
    }

    @Mutation
    public setRoles(newRoles: any) {
        const roleArray = Object.values(newRoles);
        roleArray.forEach(role => {
            switch (role) {
                case "ROLE_APP_DIGITALE":
                    this.role.app_dig = true;
                    break;
                case "ROLE_APP_DIGITALE_COMPTAGE":
                    this.role.app_dig_comptage = false;
                    break;
                case "ROLE_APP_DIGITALE_ENRICHISSEMENT":
                    this.role.app_dig_enrichissement = true;
                    break;
                case "ROLE_APP_DIGITALE_SIRENISATION":
                    this.role.app_dig_sirenisation = true;
                    break;
                default:
                    break;
            }
        });
        return true;
    }

    @Action
    public getUser(): Promise<boolean> {
        return new Promise(resolve => {
            userService.getUserCredit().then(result => {
                    if (result && result.data && result.data.credit >= 0) {
                        userService.getUser(result.data.credit).then(user => {
                            this.context.commit('setUser', user);
                        });
                        setTimeout(() => {
                            resolve(true);
                        }, 0);
                    } else {
                        alert("Un problème s'est produit avec votre solde de crédit, veuillez contacter le SAV d'infolégal au 04 72 38 32 50");
                        localStorage.removeItem('tokenJWT');
                        localStorage.removeItem('expiration');
                        localStorage.removeItem('refreshToken');
                        localStorage.removeItem('scope');
                        localStorage.removeItem('tokenType');
                        resolve(false);
                    }
                },
                error => {
                    if (error.response && error.response.status === 401 && error.response.data && error.response.data.message && error.response.data.message === "Expired JWT Token") {
                        localStorage.removeItem('tokenJWT');
                        localStorage.removeItem('expiration');
                        localStorage.removeItem('refreshToken');
                        localStorage.removeItem('scope');
                        localStorage.removeItem('tokenType');
                        resolve(false);
                    }
                });
        });
    }

    @Action
    public getRoles() {
        return new Promise(resolve => {
            userService.getRoles().then(roles => {
                this.context.commit('setRoles', roles);
            });
            setTimeout(() => {
                resolve(null);
            }, 0);
        });
    }

    @Action
    public setTempComptage(comptage: IComptage) {
        localStorage.setItem('comptage', JSON.stringify(comptage));
        localStorage.setItem('comptageTime', Date.now().toString());
        return true;
    }

}
